// POS Query keys and stale times for TanStack React Query

export const PosQueryStaleTime = {
  locations: 10 * 60 * 1000,
  menuTypes: 10 * 60 * 1000,
  subcategories: 10 * 60 * 1000,
  modifierGroups: 5 * 60 * 1000,
  products: 5 * 60 * 1000,
  drinkComponents: 5 * 60 * 1000,
  orders: 30 * 1000,
  discounts: 1 * 60 * 1000,
  default: 5 * 60 * 1000,
};

export const PosQueryKeys = {
  products: ["/v1/pos/products"] as const,
  drinkComponents: ["/v1/pos/drink-components"] as const,
  locations: ["/v1/pos/locations"] as const,
  menuTypes: ["/v1/pos/menu-types"] as const,
  orders: ["/v1/pos/orders"] as const,
  ordersByUser: (userId: string) => ["/v1/pos/orders", userId, "user"] as const,
  discounts: ["/v1/pos/discounts"] as const,
};
